/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import HeadingFieldItemEdit from "./edit-item";

const HeadingFieldEdit = () => {
    
    return (
        <FieldListEditWrapper>
            <HeadingFieldItemEdit />
        </FieldListEditWrapper>
    );
};
HeadingFieldEdit.displayName = "HeadingFieldEdit";
export { HeadingFieldEdit };
